export const headerAgencyGroupTable = [
  {
    headerStyles: 'w-[10%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[10%] py-5 break-all pl-4 align-top',
    name: 'No',
    label: 'groupAgencyId',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: true,
  },
  {
    headerStyles: 'w-[70%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[70%] py-5 break-all pl-4 align-top',
    name: 'Agency Group Name',
    label: 'agencyGroupName',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
  // {
  //   headerStyles: 'w-[50%] font-semibold py-5 pl-4 ',
  //   rowWid: 'w-[50%] py-5 break-all pl-4 align-top',
  //   name: 'Agencies',
  //   label: 'agencies',
  //   isFilter: true,
  //   isFilterDate: true,
  //   isOneLineRes: true,
  // },
  // {
  //   headerStyles: 'w-[30%] font-semibold py-5 pl-4 ',
  //   rowWid: 'w-[30%] py-5 break-all align-top pl-4 ',
  //   name: 'Total Custom Stages',
  //   label: 'totalCustomGroupStages',
  //   isFilter: true,
  //   isFilterDate: true,
  //   isOneLineRes: true,
  // },
  {
    headerStyles: 'w-[20%] font-semibold py-5 pl-4 ',
    rowWid: 'w-[20%] py-5 break-all align-top pl-4',
    name: 'Action',
    label: 'action',
    isFilter: true,
    isFilterDate: false,
    isOneLineRes: false,
  },
]
